import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function InformantADHDScalesChildhoodForm() {
    return (
        <PatientFormTemplate formTitle="Their Symptoms in Childhood" />
    );
}